import React, { useState, useEffect} from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';
import { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import SettingsUsersPermissionItem from './SettingsUsersPermissionItem';
import Api from '../../services/Api'

const PowerAppsLicenseApprovers = () => {

    const [isLoading, setLoading] = useState(false);
    const [environmentUnits, setEnvironmentUnits] = useState([]);
    const [users, setUsers] = useState({});
    const [message, setMessage] = useState();
    const [isSaving, setSaving] = useState(false);

    useEffect(() => {
        setLoading(true);
        getEnvironmentsApprovers();
    }, []);


    const getEnvironmentsApprovers = () => {
        Api.get(`/Settings/EnvironmentLicenseApprovers`)
        .then(res => res.data)
        .then(temp => {
            const users = temp.reduce((approvers, t) => {
                return {
                    ...approvers,
                    [t.id]: t.approvers.map(u => mapDbUserForPeoplePicker(u))
                }
            }, []);
            setEnvironmentUnits(temp);
            setUsers(users);
            setLoading(false);
        })
        .catch(error => {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get templates settings from database: ' + error
            });
        });
    }

    const saveSettings = () => {
        setSaving(true);

        Api.post(`/Settings/EnvironmentLicenseApprovers`, users)
        .then(res => res.data)
        .then(post => {
            if(post === 200) {
                setSaving(false);
                setMessage({
                    type: MessageBarType.success,
                    text: 'Settings have been saved.'
                });
            } else {
                setSaving(false);
                setMessage({
                    type: MessageBarType.error,
                    text: 'Cannot save settings: ' + post.message
                });
            }
        })
        .catch(error => {
            setSaving(false);
            console.log(error);
        });
    }

    const onSelectedUsers = (id, newUsers) => {
        const u = {
            ...users,
            [id]: newUsers
        }
        setUsers(u);
    }

    const msg = message && 
                <MessageBar messageBarType={message.type}>
                    {message.text}
                </MessageBar>

    const organisations = environmentUnits.map(t => 
                <SettingsUsersPermissionItem 
                    key={t.id} 
                    name={t.dimension ? t.dimension.management.value : t.environments[0].name} 
                    subname={t.dimension && t.dimension.management.key}
                    extraText={t.isDefault ? 'Default' : ''}
                    users={t.approvers}
                    onSelectedUsers={(users) => onSelectedUsers(t.id, users)} 
                />)
        const btn = isSaving
                ? <Spinner className='settings-btn' size={SpinnerSize.large} />
                : <PrimaryButton className='settings-btn' onClick={saveSettings}>Save</PrimaryButton>

    return (
        <div>
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div className='settings-container'>
                    {organisations}
                    {btn}
                    {msg}
                </div>
            }
        </div>
    );
}

export default PowerAppsLicenseApprovers;


// WEBPACK FOOTER //
// ./src/components/Settings/PowerAppsLicenseApprovers.js